import HTTP from '@/utils/http';

const CategoriesBasic = {
  getCategoriesBasic: categoryId => HTTP.get(`category-geo-basic?with=${categoryId}`).then(response => response.data),

  getCategoryBasic: id => HTTP.get(`category-geo-basic?id=${id}`).then(response => response.data),
};

export default CategoriesBasic;
